import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import Admin from './Admin';
import Frontend from './Frontend';
import "./utils/i18n";
import { QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from 'react-query/devtools';
import './css/index.css'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000,        // 1 min — don't refetch data that's still fresh
            cacheTime: 5 * 60 * 1000,    // 5 min — keep unused data in cache before GC
            refetchOnWindowFocus: false,  // don't refetch just because the user switched tabs
            retry: 1,                    // fail fast — 1 retry instead of 3
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <Routes>
                    <Route path='/admin/*' element={<Admin />} />
                    <Route path='/*' element={<Frontend />} />
                </Routes>
            </BrowserRouter>
            {/*<ReactQueryDevtools />*/}
        </QueryClientProvider>
    </React.StrictMode>
)